import React from 'react';
import CheckSmsIcon from './CheckSmsIcon';
import InputSmsField from './InputSmsField';
import ShowReminderCheckBox from './ShowReminderCheckbox';

type Props = {
  fullShowList: any,
  currentShowList: any,
  isValidPhoneNum: boolean,
  formStep: number,
  handleCheckbox: any,
  numbersEligibleUSCanada: string,
  setUserInfo: Function,
  userInfo: any,
  tosUserAgreement: boolean,
  setTosUserAgreement: Function,
  savedShows: any,
}

function ShowSmsFormStepTwo({
  fullShowList,
  currentShowList,
  isValidPhoneNum,
  formStep,
  handleCheckbox,
  numbersEligibleUSCanada,
  setUserInfo,
  userInfo,
  tosUserAgreement,
  setTosUserAgreement,
  savedShows,
} : Props) {
  return (
    <div className="mt-3 mb-5">
      <div className="mb-1">
        <p className="text-center text-[15px] leading-normal text-darkCyan font-semibold italic">
          {numbersEligibleUSCanada}
        </p>
      </div>
      <div className="flex flex-col items-center w-full mb-2 text-center">
        <InputSmsField
          disabled={formStep > 1}
          label="Phone"
          validValue={isValidPhoneNum}
          name="phone"
          value={userInfo.phone}
          setUserInfo={setUserInfo}
          placeholder="123-456-7890"
          userInfo={userInfo}
        />
        <InputSmsField
          disabled={formStep > 1}
          label="First Name"
          validValue={!!userInfo.firstName}
          name="firstName"
          value={userInfo.firstName}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          placeholder="First Name"
        />
        <InputSmsField
          disabled={formStep > 1}
          label="Last Name"
          validValue={!!userInfo.lastName}
          name="lastName"
          value={userInfo.lastName}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          placeholder="Last Name"
        />
        <div className="mt-10">
          <p className="font-semibold text-black">
            Receive updates for CHD.TV via SMS:
          </p>
          <ShowReminderCheckBox
            formStep={formStep}
            currentShowList={currentShowList}
            fullShowList={fullShowList}
            handleCheckBox={handleCheckbox}
            savedShows={savedShows}
          />
          <div className="mx-[10px] md:mx-[50px] my-5 text-black ">
            <div className="flex items-start mb-1 text-left">
              <label htmlFor="agreement" className="relative flex space-x-1">
                <input
                  type="checkbox"
                  onChange={() => {
                    if (formStep === 1) {
                      setTosUserAgreement(!tosUserAgreement);
                    }
                  }}
                  name="agreement"
                  id="agreement"
                  disabled={formStep > 1}
                  checked={tosUserAgreement}
                  className="w-[16px] h-[16px] appearance-none border-chdGrey peer border rounded-[1.5px] shadow shadow-checkbox mr-1"
                />
                <CheckSmsIcon />
                <p className="ml-1 font-semibold leading-[18px]">
                  You are required to agree to sign up.
                </p>
              </label>
            </div>
            <p className="mt-2 ml-6 italic font-semibold leading-normal text-left text-darkCyan">
              {' '}
              You agree to receive automated promotional messages. You also
              agree to
              {' '}
              <a
                className="font-bold underline text-darkCyan"
                href="https://childrenshealthdefense.org/about-us/terms-of-use/"
                target="_blank"
                rel="noreferrer"
              >
                Terms of Use
              </a>
              {' '}
              and
              {' '}
              <a
                className="font-bold underline text-darkCyan"
                href="https://childrenshealthdefense.org/about-us/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
              . This agreement isn&#39;t a condition of any purchase. Text
              message rates may apply. Reply STOP to end.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShowSmsFormStepTwo;
